import actions from 'constants/reducers';
import { useAppContext } from 'hooks/useAppContext';
import { useLoadTruckers } from 'hooks/useLoadTruckers';
import { useToast } from 'hooks/useToast';
import { useParams } from 'react-router-dom';
import { purchaseExtraSuggestedTruckers } from 'services/payPerUse';

export const usePurchaseExtraSuggestedTruckers = () => {
  const { freightId } = useParams();
  const {
    state: {
      truckers: { radius },
    },
    dispatch,
  } = useAppContext();
  const { createToast } = useToast();
  const { fetchTruckers } = useLoadTruckers('lazy');

  const fetchPurchaseExtraSuggestedTruckers = async () => {
    dispatch({ type: 'suggested_truckers_extension_loading' });

    try {
      await purchaseExtraSuggestedTruckers({ freightId });

      fetchTruckers(radius);

      dispatch({ type: 'suggested_truckers_extension_success' });
      dispatch({ type: actions.modals.setClosePurchaseExtraSuggestedTruckers });

      createToast({
        severity: 'success',
        heading: 'Lista de motorista desbloqueada com sucesso.',
      });
    } catch (errorMessage) {
      dispatch({ type: 'suggested_truckers_extension_error' });

      createToast({
        severity: 'error',
        heading: 'Não foi possível desbloquear a lista de motorista.',
      });
    }
  };

  return { fetchPurchaseExtraSuggestedTruckers };
};
